<template>
  <div style="padding-bottom: 5px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>Home</el-breadcrumb-item>
      <el-breadcrumb-item>Administrator</el-breadcrumb-item>
      <el-breadcrumb-item>Contract T&C Template</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <el-card>
    <template #header>
      <div>Contract T&C Template</div>
    </template>
    <div v-if="type == 'edit'">
      <EditTemplate />
    </div>
    <div v-if="type == 'list'">
      <ListTemplate />
    </div>
  </el-card>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useRoute } from 'vue-router';
import EditTemplate from './edit/index.vue';
import ListTemplate from './list/index.vue';

const route = useRoute();

console.log('router', route.query);

const type = ref('list');
if (route.query.type) {
  type.value = route.query.type;
}
</script>
<style scoped></style>
